import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export interface EmptyStateProps {
  icon: ReactNode;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
  iconClassName?: string;
}

export function EmptyState({ icon, title, description, action, className, iconClassName }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'text-center py-12 px-4 bg-slate-50 border border-dashed border-slate-300 rounded-2xl space-y-3',
        className,
      )}
    >
      <div
        className={cn(
          'w-12 h-12 bg-slate-200 text-slate-500 rounded-2xl flex items-center justify-center mx-auto',
          iconClassName,
        )}
      >
        {icon}
      </div>
      <div>
        <h3 className="text-sm font-bold text-slate-800">{title}</h3>
        {description && <p className="text-xs text-slate-500 mt-0.5 max-w-md mx-auto">{description}</p>}
      </div>
      {action}
    </div>
  );
}
